import { Component, inject } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-default-footer',
  template: `
    <footer class="app-footer">
      <span>© {{ year }} {{ config.appName }} · v{{ config.appVersion }}</span>
    </footer>
  `,
  styles: `
    .app-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      padding: 0.9rem 1.5rem;
      font-size: 0.78rem;
      color: var(--app-muted);
      border-top: 1px solid var(--app-border);
    }
  `,
})
export class DefaultFooterComponent {
  protected readonly config = inject(ConfigurationService);
  protected readonly year = new Date().getFullYear();
}
